import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import HubPage from '../HubPage';
import withAuthProvider from '../../../services/Auth/AuthProvider';
import {
  fetchApplicationData,
  storeRedirectionUrls,
  showModal,
  getUserActivities,
  showLoader,
} from '../Actions/HubActions';
import { getAuth } from '../../../services/Auth/AuthActions';

const mapStateToProps = (state) => {
  return {
    appData: state.HubReducer.appData,
    isModal: state.HubReducer.isModal,
    isLoader: state.HubReducer.isLoader,
    languageCode: state.HubReducer.languageCode,
  };
};
function mapDispatchToProps(dispatch) {
  return {
    fetchApplicationData: (languageCode) => {
      dispatch(fetchApplicationData(languageCode));
    },
    storeRedirectionUrls: (openedTab) => {
      dispatch(storeRedirectionUrls(openedTab));
    },
    showModal: (show) => {
      dispatch(showModal(show));
    },
    getUserActivities: (token) => {
      dispatch(getUserActivities(token));
    },
    showLoader: (isLoader) => {
      dispatch(showLoader(isLoader));
    },
    getAuth: () => {
      dispatch(getAuth());
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withAuthProvider(HubPage)));
